import React, { useEffect, useState } from "react";
import { FiAlertTriangle } from "react-icons/fi";
import axiosInstance from "../../../axios/axios";
import { useParams } from "react-router-dom";
import moment from "moment";

import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";

const AllergiesCard = ({ onExportData }) => {
  const params = useParams();

  const [data, setData] = useState([]);

  const StatusClass = (St) => {
    if (St === "Inactive") {
      return "inactive-status";
    } else {
      return "active-status";
    }
  };

  const getAllergiesData = () => {
    let currentData = "pid=" + params.pid;

    let encryptedData = Encrypt_Value(currentData, "vozo");

    axiosInstance
      .get("/vozo/patient/allergy?search=" + encryptedData)
      .then((response) => {
        let decodingResponse = Decrypt_Value(response.data, "vozo");

        const formatted = (
          Array.isArray(decodingResponse) ? decodingResponse : []
        ).map((item) => ({
          allergy: item.specific_drug_allergy || "-",

          addedDate:
            item.date && item.date !== "0000-00-00"
              ? moment(item.date).format("MMM DD, YYYY")
              : "-",

          status: item.status || "-",
        }));

        /* UI → latest 3 */

        const latestThree = formatted.slice(0, 3);

        setData(latestThree);

        /* PARENT → FULL DATA */

        if (onExportData) {
          onExportData(
            formatted.map((item) => ({
              title: item.allergy,
              subText: item.addedDate,
              status: item.status,
            })),
          );
        }
      })
      .catch(() => {
        setData([]);
      });
  };

  useEffect(() => {
    getAllergiesData();
  }, [params.pid]);

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FiAlertTriangle className="care-summary-main-icon" />

        <h3 className="care-summary-title">Allergies</h3>
      </div>

      <div className="care-summary-body">
        {data.length === 0 ? (
          <div className="care-summary-empty">No Allergies Added</div>
        ) : (
          data.map((item, index) => (
            <div
              key={index}
              className={`care-summary-row ${
                index !== data.length - 1 ? "care-summary-border" : ""
              }`}
            >
              <div className="care-summary-content">
                <div className="care-summary-heading">{item.allergy}</div>

                <div className="care-summary-subtext">
                  Added date: {item.addedDate}
                </div>
              </div>

              <div
                className={`care-summary-status-wrap ${StatusClass(
                  item.status,
                )}`}
              >
                <span className="care-summary-status-dot"></span>

                <span className="care-summary-status-text">{item.status}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(AllergiesCard);
